import * as React from "react";
import { SectionHeader } from "../SharedComponents";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { AddAddress } from "./AddAddress";
import { Email } from "../../../../../../../react-core/Html/Validation/RegExPatterns";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../Shared/Process/Process/WizardLinter";
import { ValidatorContents } from "../../../../../Common/ValidatorHelper";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { FullClientDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { EmailAddressType } from "../../../../../../../Wrap/Constants/Enums/EmailAddressType";
import { EWizardLinterHelper } from "../../Resource/EWizardLinterHelper";
import { AddressDetailModel } from "../../../../../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { PhoneNumberDetails } from "../../../Common/ClientDetails/PhoneNumberDetails";
import { FullClientDetailHelper } from "../../../Common/FullClientDetail/FullClientDetailHelper";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";

interface IContactDetailProps extends IProcessComponentProps {
    onCCMChange: (changes) => void;
    data: FullClientDetailModel;
    disableWhenFullClient: boolean;
    isAddNewProduct?: boolean;
    existingClientInfo?: FullClientDetailModel;
    onCorrespondenceAddressChange: (changes) => void;
}

interface IContactDetailState {
    UseAddressForCorrespondence?: boolean;
    disableAddress: boolean;
}

export class ContactDetail extends ProcessComponent<IContactDetailProps, IContactDetailState> {
    constructor(props: any) {
        super(props);
        this.state = {
            UseAddressForCorrespondence: null,
            disableAddress: false,
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.updateUseAddressForCorrespondence();
        this.checkDisableStatus();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);

        if (
            prevProps.data?.ActorId !== this.props.data?.ActorId ||
            prevProps.data?.AddressDetails.length !== this.props.data?.AddressDetails.length
        ) {
            this.updateUseAddressForCorrespondence();
            if (this.props.disableWhenFullClient == true) {
                this.checkDisableStatus();
            }
        }
    }

    private updateUseAddressForCorrespondence() {
        if (this.props.data.AddressDetails?.length > 0) {
            this.setState({
                UseAddressForCorrespondence: this.isSameCorrespondenceAddress(this.props.data.AddressDetails),
            });
        }
    }

    private isSameCorrespondenceAddress(addressDetails: AddressDetailModel[]): boolean {
        if (addressDetails.length < 2) {
            return true;
        }
        const postalAddress = addressDetails?.find((ele) => ele.PhysicalAddressType == PhysicalAddressType.Postal);
        const residentialAddress = addressDetails?.find(
            (ele) => ele.PhysicalAddressType == PhysicalAddressType.Residential
        );

        const isSameCorrespondenceAddress =
            !CommonHelper.isNullOrEmpty(postalAddress) &&
            !CommonHelper.isNullOrEmpty(residentialAddress) &&
            FullClientDetailHelper.isSameAddress(postalAddress?.Address, residentialAddress?.Address);

        return isSameCorrespondenceAddress;
    }

    private checkDisableStatus() {
        if (this.props.disableWhenFullClient) {
            this.setState({
                disableAddress: this.getBlockStatus(this.props.existingClientInfo) == EWizardLinterStatus.PleaseCheck,
            });
        }
        if (this.props.isAddNewProduct) {
            this.setState({
                disableAddress: true,
            });
        }
    }

    private resetUseAddressForCorrespondence() {
        const data = this.props.data.AddressDetails;
        const index = data?.findIndex((ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential);

        const postalindex = index == 1 ? 0 : 1;
        data.splice(postalindex, 1);
        this.props.onCCMChange([{ value: data, path: `AddressDetails` }]);
        this.setState({
            UseAddressForCorrespondence: false,
        });
    }

    private hasResident(): boolean {
        return this.props.data.AddressDetails?.some(
            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
        );
    }

    validAddress(address: AddressDetailModel): boolean {
        return (
            address?.Address?.Address1 != null &&
            address?.Address?.Address1 != "" &&
            address?.Address?.Country != null &&
            address?.Address?.PostCode != null &&
            address?.Address?.PostCode != ""
        );
    }

    getBlockStatus(model: FullClientDetailModel): EWizardLinterStatus {
        const data = model?.AddressDetails;
        if (!data || data.length == 0) {
            return EWizardLinterHelper.getEWizardLinterStatus(false);
        }
        const residential = data?.find((x) => x?.PhysicalAddressType == PhysicalAddressType.Residential);
        const postal = data?.find((x) => x?.PhysicalAddressType == PhysicalAddressType.Postal);

        const complete = this.validAddress(residential) && this.validAddress(postal);

        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    private setPostalAddress = (v: boolean) => {
        const postalAddress = FullClientDetailHelper.setPostalAddress(v, this.props.data);
        this.props.onCCMChange(postalAddress);
    };

    render() {
        const { data } = this.props;
        const { disableAddress, UseAddressForCorrespondence } = this.state;
        return (
            <>
                {SectionHeader("Contact details")}
                <WizardLinter status={this.getBlockStatus(data)} enabled={true}>
                    <AddAddress
                        label="Residential address"
                        onAddressChange={(v) => this.props.onChange({ Address: v })}
                        address={data.AddressDetails?.find(
                            (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                        )}
                        canChooseCountry={false}
                        index={
                            data?.AddressDetails == null || data.AddressDetails?.length == 0
                                ? 0
                                : !this.hasResident()
                                ? 1
                                : data.AddressDetails?.findIndex(
                                      (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                                  )
                        }
                        onCCMChange={(changes) => {
                            this.props.onCCMChange(changes);
                        }}
                        addressType={PhysicalAddressType.Residential}
                        addressList={data.AddressDetails}
                        resetUseAddressForCorrespondence={() => this.resetUseAddressForCorrespondence()}
                        onRef={(ref) => this.appendChild(ref)}
                        onChange={() => {}}
                        data={null}
                        disabled={disableAddress}
                    />
                </WizardLinter>

                {data.AddressDetails && this.hasResident() && (
                    <>
                        <RadiosEditor
                            cssWrapper="rg-inline mb-16"
                            selected={UseAddressForCorrespondence}
                            label={"Use this address for all correspondence"}
                            options={[true, false]}
                            getText={(v) => (v ? "Yes" : "No")}
                            disabled={disableAddress}
                            required={"Please select"}
                            onChange={(v) => {
                                this.setPostalAddress(v);
                                this.setState({ UseAddressForCorrespondence: v });
                                this.props.onCorrespondenceAddressChange(v);
                            }}
                        />
                        {this.state.UseAddressForCorrespondence == false && (
                            <AddAddress
                                label="Correspondence address"
                                onAddressChange={(v) => this.props.onChange({ CorrespondenceAddress: v })}
                                address={data.AddressDetails?.find(
                                    (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Postal
                                )}
                                canChooseCountry={false}
                                index={
                                    data.AddressDetails.findIndex(
                                        (ele) => ele?.PhysicalAddressType == PhysicalAddressType.Residential
                                    ) == 0
                                        ? 1
                                        : 0
                                }
                                onCCMChange={(changes) => {
                                    this.props.onCCMChange(changes);
                                }}
                                addressType={PhysicalAddressType.Postal}
                                addressList={data.AddressDetails}
                                onRef={(ref) => this.appendChild(ref)}
                                onChange={() => {}}
                                data={null}
                                disabled={disableAddress}
                            />
                        )}
                    </>
                )}
                <div className="row">
                    <div className="col-fluid col-max-430">
                        <TextBoxEditor
                            value={data?.EmailAddressDetails?.[0]?.EmailAddress}
                            label={"Email address"}
                            inputMode={"email"}
                            regex={{ errorMessage: ValidatorContents.InvalidEmail, value: Email }}
                            disabled={disableAddress}
                            onChange={(v) => {
                                this.props.onCCMChange([
                                    { value: v, path: "EmailAddressDetails.0.EmailAddress" },
                                    { value: EmailAddressType.Primary, path: "EmailAddressDetails.0.EmailAddressType" },
                                ]);
                            }}
                        />
                    </div>
                </div>

                <PhoneNumberDetails
                    data={data.PhoneNumberDetails}
                    onChange={(value) => {
                        this.props.onCCMChange([{ value: value, path: "PhoneNumberDetails" }]);
                    }}
                    disabled={disableAddress}
                    onRef={(ref) => this.appendChild(ref)}
                />
                <hr className="mb-20" />
            </>
        );
    }
}
